import { TabList, TabButton } from '../tab-styles';

export enum ActionCenterTab {
    ToDo = 'to-do',
    LivingDonorMoves = 'living-donor-moves',
    DeceasedDonorCases = 'deceased-donor-cases',
    MoveTracker = 'move-tracker',
    Support = 'support'
}

const tabs = [
    { key: ActionCenterTab.ToDo, label: 'To-Do' },
    { key: ActionCenterTab.DeceasedDonorCases, label: 'DD Cases' },
    { key: ActionCenterTab.LivingDonorMoves, label: 'LDK Moves' },
    { key: ActionCenterTab.MoveTracker, label: 'Move Tracker' },
    // { key: ActionCenterTab.Support, label: 'Support (Help Desk)' }
];

interface IProps {
    activeKey: string,
    onSelect: (key: ActionCenterTab) => void
}

const ActionCenterTabs = ({ activeKey, onSelect }: IProps) => (
    <TabList role='tablist' aria-label='Action Center'>
        {tabs.map(tab => {
            const active = tab.key === activeKey;
            
            return (
                <TabButton key={tab.key} type='button' role='tab' aria-selected={active} $active={active} onClick={() => onSelect(tab.key)}>
                    {tab.label}
                </TabButton>
            );
        })}
    </TabList>
);

export default ActionCenterTabs;
